import { useStoryblokConfig } from '../../context/storyblokConfigContext'
import { DesktopPrimaryHeader } from '../Header/DesktopPrimaryHeader'
import { useState } from 'react'
import { useRecoilState } from 'recoil'
import { HeaderLayout } from '@/app/common/components/Header/HeaderLayout'
import { MobilePrimaryHeader } from '@/app/common/components/Header/MobilePrimaryHeader'
import { MobileSubHeader } from '@/app/common/components/Header/MobileSubHeader'
import {
  PrimaryHeaderCheckout,
  TabletPrimaryHeader,
} from '@/app/common/components/Header/TabletPrimaryHeader'
import { Menu } from '@/app/common/components/Layout/Menu/Menu'
import { useRecoilStateWithSSRFallback } from '@/app/common/recoil'
import {
  dealCalculationState,
  selectedItemsState,
} from '@/domains/checkout/checkout.state'

interface Props {
  shouldRenderCheckoutHeader: boolean
  shouldRenderSubHeader: boolean
}

export default function Header({
  shouldRenderSubHeader,
  shouldRenderCheckoutHeader,
}: Props) {
  const { config } = useStoryblokConfig()
  const { navigation_bar } = config
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => setMenuOpen(!menuOpen)

  const [items] = useRecoilStateWithSSRFallback(selectedItemsState, [])
  const [dealCalculation] = useRecoilState(dealCalculationState)

  const itemsCount = items.length
  const itemsTotalAmount =
    dealCalculation?.dealValuesEntry.payoutAmount.toFixed(2) as string

  const navMenu = (
    <Menu open={menuOpen} closeMenu={setMenuOpen.bind(null, false)} />
  )

  if (shouldRenderCheckoutHeader) {
    return (
      <HeaderLayout
        primaryHeader={
          <>
            <PrimaryHeaderCheckout
              menuOpen={menuOpen}
              toggleMenu={toggleMenu}
              itemsCount={0} // dont show cart as we are already in the checkout
              itemsTotalAmount=""
            />
            <MobilePrimaryHeader
              isCheckout
              menuOpen={menuOpen}
              toggleMenu={toggleMenu}
              itemsCount={itemsCount}
              itemsTotalAmount={itemsTotalAmount}
            />
          </>
        }
        navMenu={navMenu}
      />
    )
  }

  return (
    <HeaderLayout
      primaryHeader={
        <>
          <TabletPrimaryHeader
            menuOpen={menuOpen}
            toggleMenu={toggleMenu}
            itemsCount={itemsCount}
            itemsTotalAmount={itemsTotalAmount}
          />

          <DesktopPrimaryHeader
            menuOpen={menuOpen}
            toggleMenu={toggleMenu}
            itemsCount={itemsCount}
            itemsTotalAmount={itemsTotalAmount}
            navigationBar={navigation_bar}
          />

          <MobilePrimaryHeader
            menuOpen={menuOpen}
            toggleMenu={toggleMenu}
            itemsCount={itemsCount}
            itemsTotalAmount={itemsTotalAmount}
          />
        </>
      }
      navMenu={navMenu}
      subHeader={shouldRenderSubHeader && <MobileSubHeader />}
    />
  )
}
